/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.bluetooth = {};
    Blockly.Blocks.bluetooth.style = 'bluetooth_blocks';
    Blockly.Blocks.bluetooth_init = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_INIT)
                .appendField("RX").appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "RX")
                .appendField("TX").appendField(new Blockly.FieldDropdown(profile["default"].rxtx), "TX")
                .appendField(new Blockly.FieldDropdown([
                    ["2400", "2400"],
                    ["4800", "4800"],
                    ["9600", "9600"],
                    ["19200", "19200"],
                    ["38400", "38400"],
                    ["57600", "57600"],
                    ["115200", "115200"]
                ]), "BAUD").appendField(Blockly.Msg.BLUETOOTH_BAUDRATE);
                ;
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_init2 = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_INIT)
                .appendField(new Blockly.FieldDropdown([
                    ["2400", "2400"],
                    ["4800", "4800"],
                    ["9600", "9600"],
                    ["19200", "19200"],
                    ["38400", "38400"],
                    ["57600", "57600"],
                    ["115200", "115200"]
                ]), "BAUD");
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_name_simple = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_DEVNAME);
            this.appendValueInput("DEVNAME", "String")
                .setCheck("String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(true);
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null)
        }
    };
    Blockly.Blocks.bluetooth_timeout = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_FIX);
            this.appendValueInput("MS", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT)
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH_TIMEOUT);            
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_print = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_PRINT);
            this.appendValueInput("STRINGOUTPUT", "String").setAlign(Blockly.ALIGN_RIGHT);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldCheckbox("TRUE"), "NEWLINE")
                .appendField(Blockly.Msg.BLUETOOTH_ADD_NEW_LINE);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_println = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_PRINTLN);
            this.appendValueInput("STRINGOUTPUT", "String")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_read_float = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_READFLOAT);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldCheckbox("TRUE"), "NEWLINE")
                .appendField(Blockly.Msg.BLUETOOTH_UNTIL_NEW_LINE);
            this.setInputsInline(!0);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.bluetooth_read_string = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_READSTRING);
            this.appendDummyInput("")
                .appendField(new Blockly.FieldCheckbox("TRUE"), "NEWLINE")
                .appendField(Blockly.Msg.BLUETOOTH_UNTIL_NEW_LINE);
            this.setInputsInline(!0);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.bluetooth_read_string_line = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_READSTRINGLINE);
            this.setOutput(!0, "String")
        }
    };
    Blockly.Blocks.bluetooth_read_byte = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_READBYTE);
            this.setOutput(!0, "Number")
        }
    };
    Blockly.Blocks.bluetooth_write_byte = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_WRITEBYTE);
            this.appendValueInput("BYTE", "Number")
                .setCheck("Number")
                .setAlign(Blockly.ALIGN_RIGHT);
            this.setInputsInline(!0);
            this.setPreviousStatement(!0, null);
            this.setNextStatement(!0, null)
        }
    };
    Blockly.Blocks.bluetooth_read_available = {
        helpUrl: "",
        shopUrl: "",
        init: function() {
            this.setStyle(Blockly.Blocks.bluetooth.style);
            this.appendDummyInput("")
                .appendField(Blockly.Msg.BLUETOOTH)
                .appendField(new Blockly.FieldImage(img_path + "arduino/bluetooth.svg", 35, 35))
                .appendField(Blockly.Msg.BLUETOOTH_AVAILABLE);
            this.setOutput(!0, "Boolean")
        }
    };
}